import React, { useEffect, useState } from "react";
import { FormProvider } from "react-hook-form";
import { useNavigate, useParams } from "react-router";
import { toast } from "react-toastify";
import { FormatDateTime } from "../../../../../../utils/functions/ResourceFunctions";
import {
  useApproveDeclinePIPMutation,
  useGetSingleMainPIPQuery,
} from "../../../../../api/hrApi";
import DashboardStyle from "../../../../../dashboard/Styles/Dashboard.module.css";
import { ActionButtons } from "../../../../../global/components/Buttons/buttons";
import { FormTemplate } from "../../../../Components/Forms/InputTemplate";
import PageLayout from "../../../../Components/Layout/PageLayout";
import { getStatusText } from "../../../Finance/CostCenter/Class";
import ApproveModal from "../Modals/ApproveModal";
import { AppraisalDeclineModal } from "../Modals/DeclineModal";
import { DEFINED_PERMISSIONS } from "../../../../../../utils/const";
export const ViewSingleMainPIP = () => {
  const { id } = useParams();
  const { data } = useGetSingleMainPIPQuery(id);
  const navigation = useNavigate();
  const [approveDecline, { isLoading }] = useApproveDeclinePIPMutation();
  const [openApproveModal, setOpenApproveModal] = React.useState(false);
  const [openDeclineModal, setOpenDeclineModal] = React.useState(false);
  const [matchedPermissionHr, setMatchedPermissionHr] = useState("");
    const declineVariable = 1;
  const approveVaiable = 0;
  useEffect(() => {
    const userPerm = JSON.parse(localStorage.getItem("x-u-perm"));
    const hrPerm = [
      DEFINED_PERMISSIONS.SeniorHRManager,
      DEFINED_PERMISSIONS.PrimaryHRManager,
      DEFINED_PERMISSIONS.HODApprove,
    ];
    if (userPerm && userPerm.some((perm) => hrPerm.includes(perm))) {
      const matchedPerm = userPerm.find((perm) => hrPerm.includes(perm));
      setMatchedPermissionHr(matchedPerm);
    } else {
      setMatchedPermissionHr("");
    }
  }, []);
  const [comment, setComment] = React.useState("");
  const handleComment = (e) => {
    setComment(e.target.value);
  };
  const declineAction = async (type) => {
    if (!comment && type === 1) {
      toast.error("Please enter a comment");
      return;
    }
    try {
      const response = await approveDecline({
        id,
        comment,
        approvalType: type,
      }).unwrap();
      if (response?.successful) {
        setOpenDeclineModal(false);
        setOpenApproveModal(false);
        toast.success(response?.statusMessage);
        navigation(
          "/dashboard/hr/HR-Appraisal-Setup/performance-improvement-plan"
        );
      }
    } catch (error) {
      toast.error(error?.data?.statusMessage ?? "Error approving rating scale");
    }
  };

  const handleApproveModal = () => setOpenApproveModal(!openApproveModal);
  const handleDeclineModal = () => setOpenDeclineModal(!openDeclineModal);

  return (
    <PageLayout
      title={"Employee PIP Details"}
      hasBack={true}
      backURL={"/dashboard/hr/HR-Appraisal-Setup/performance-improvement-plan"}
    >
      <div className={DashboardStyle.app_view_controls}></div>
      <FormProvider>
        <FormTemplate className={DashboardStyle.view_app_components}>
          <section
            style={{
              backgroundColor: "#F8FBF8",
              border: "1px solid #D9E9DA",
              borderRadius: "8px",
            }}
            className={DashboardStyle.form_section}
          >
            <h4 className={DashboardStyle.form_section_title}>
              Process <br /> Information
            </h4>
            <div className={DashboardStyle.labels_group}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(32.3%, 1fr))",
                  gap: "10px",
                }}
              >
                <div>
                  <p>Pip Objective:</p>
                  <h4>{data?.responseObject?.pipObjective}</h4>
                </div>
                <div>
                  <p>Expected Improvement:</p>
                  <h4>{data?.responseObject?.expectedImprovement}</h4>
                </div>
                <div>
                  <p>Development Plan:</p>
                  <h4>{data?.responseObject?.developmentPlan}</h4>
                </div>
                <div>
                  <p>Target Improvement Percent:</p>
                  <h4>{data?.responseObject?.targetImprovementPercent}%</h4>
                </div>
                <div>
                  <p>Engagement Hours:</p>
                  <h4>{data?.responseObject?.engagementHours}</h4>
                </div>
                <div>
                  <p>Appraisee Comment:</p>
                  <h4>{data?.responseObject?.appraiseeComment}</h4>
                </div>
                <div>
                  <p>Start Date:</p>
                  <h4>
                    {FormatDateTime(
                      data?.responseObject?.startDate,
                      "DD/MM/YYYY"
                    )}
                  </h4>
                </div>
                <div>
                  <p>End Date:</p>
                  <h4>
                    {FormatDateTime(
                      data?.responseObject?.endDate,
                      "DD/MM/YYYY"
                    )}
                  </h4>
                </div>
                <div>
                  <p>Approval Status:</p>
                  <h4>
                    {typeof data?.responseObject?.approvalStatus === "number"
                      ? getStatusText(data?.responseObject?.approvalStatus)
                      : data?.responseObject?.approvalStatus}
                  </h4>
                </div>
                <div>
                  <p>Created Date:</p>

                  <h4>
                    {FormatDateTime(
                      data?.responseObject?.createdDate,
                      "DD/MM/YYYY"
                    )}
                  </h4>
                </div>
              </div>
            </div>
          </section>
          {matchedPermissionHr && data?.responseObject?.approvalStatus !== 0 && (
            <div className={DashboardStyle.button_cage}>
              <button
                width={"auto"}
                className={DashboardStyle?.button_cage_weight}
                onClick={handleApproveModal}
                type="button"
              >
                Approve
              </button>
              <ActionButtons
                width={"auto"}
                className={DashboardStyle?.button_cage_weight}
                style={{ backgroundColor: "red" }}
                onClick={handleDeclineModal}
                type="button"
              >
                Decline
              </ActionButtons>
            </div>
          )}
        </FormTemplate>
      </FormProvider>
      {openDeclineModal && (
        <AppraisalDeclineModal
          openModal={openDeclineModal}
          closeModal={handleDeclineModal}
          handleComment={handleComment}
          handleDelete={() => declineAction(declineVariable)}
          isLoading={isLoading}
        />
      )}
      <ApproveModal
        isOpen={openApproveModal}
        handleClose={handleApproveModal}
        handleDelete={() => declineAction(approveVaiable)}
        handleComment={handleComment}
        isLoading={isLoading}
        headText={"Approve Employee PIP"}
      />
    </PageLayout>
  );
};
